import { SLUser } from './IdentityConfig';
import { WorkflowConfig } from './WorkflowConfig';

/**
 * The options to pass into {@link @samelogic/samelogic-js#Samelogic} initialization.
 *
 * @public
 */
export interface Options {
  /**
   * The `ENV_ID` provided, which you have received for creating a project on the Samelogic platform.
   */
  envId: string;

  baseUrl?: string;

  /**
   * The list of currently **active** workflows. Worklows must be published to be active.
   */
  workflows: WorkflowConfig[];

  user?: SLUser;
}
